import { fetchData } from "./fetchData";

export const registerAPI = async (userData) => {
    const route = `/auth/register`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const loginAPI = async (userData) => {
    const route = `/auth/login`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const getUsersPermissions = async (userID) => {
    const route = `/admin/users/permissions/${userID}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

export const forgotPasswordAPI = async (Email) => {
    const route = `/auth/forgotpassword`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({Email})
    }

    let response = await fetchData(route, options);

    return response;
}

export const resetPasswordAPI = async (userData) => {
    const route = `/auth/resetpassword`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const changePasswordAPI = async (userID, userData) => {
    const route = `/auth/changepassword/${userID}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const logoutAPI = async () => {
    const route = `/auth/logout`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    }

    let response = await fetchData(route, options);

    return response;
}

export const getMeAPI = async () => {
    const route = `/auth/me`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}